<template>
  <div class="wrapper-login">
    <div class="wrapper-form">
      <div class="container">
        <img src="@/assets/logo/LogoYellow.svg" alt="" class="logo" />
        <div class="container-inputs">
          <LoginInput
            v-model:text="userName.val"
            :value="userName.val"
            :label="'Nombre de usuario'"
            :has-error="userName.enabled"
            :error="userName.errors.length === 0 ? '' : userName.errors[0]"
          />
          <LoginInput
            v-model:text="password.val"
            :value="password.val"
            :label="'Contraseña'"
            :has-error="password.enabled"
            :error="password.errors.length === 0 ? '' : password.errors[0]"
            is-password="true"
          />
        </div>
        <div class="wrapper-buttons">
          <LoginButton
            :buttonLabel="'Ingresar'"
            @click="loginTransaction"
            :is-disabled="successForm"
          />
          <a href="/store" class="download-link" target="_blank"
            >Descargar app para Android</a
          >
        </div>
      </div>
    </div>
    <div class="wrapper-image">
      <img src="@/assets/images/LoginImage.png" alt="" class="image" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import LoginInput from "@/components/commons/controls/LoginInput.vue";
import { loginValidator } from "@/ux/login/validators/loginValidator";
import LoginButton from "@/components/commons/controls/LoginButton.vue";
import { loginUse } from "@/ux/login/use/loginUse";
import { inject } from "vue";
import { spinnerProcessKey } from "@/main";

export default defineComponent({
  name: "LoginView",
  components: {
    LoginInput,
    LoginButton,
  },

  setup() {
    const spinnerProcess = inject(spinnerProcessKey)!;
    const { offSpinnerState, onSpinnerState } = spinnerProcess;
    const { userName, password, successForm, reset } = loginValidator();
    const { authenticate } = loginUse();

    async function loginTransaction() {
      try {
        await onSpinnerState();
        await authenticate(userName.value.val ?? "", password.value.val ?? "");
        await offSpinnerState();
        reset();
      } catch (error) {
        await offSpinnerState();
        throw error;
      }
    }

    return {
      userName,
      password,
      successForm,
      reset,
      loginTransaction,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/login/styles/loginStyle";
</style>
